import React from "react";
import { useTranslation } from "react-i18next";
import ConvertToString from "../../../../../components/Converter";
import KiloNewtonDividedByMillimetreSquared from "../../../../../components/Math/Units/Metric/KiloNewtonDividedByMillimetreSquared";
import { RowBody } from "../../../../../components/RowValue/RowBody";

function CharakteristischeFestigkeit({ charakteristischeFestigkeit }) {
  const { t } = useTranslation("translation");
  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterTragglied.characteristicStrengh")}</p>}
      indicesValue={
        <span>
          f<sub>y,k</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(charakteristischeFestigkeit, 3)}</span>}
      unitValue={<KiloNewtonDividedByMillimetreSquared />}
    />
  );
}

export default CharakteristischeFestigkeit;
